var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end my-1" },
          [
            _vm.HasPermission(_vm.PermissionList.Sales_Create)
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.sendSO()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v("Add Proforma"),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                staticClass: "w-50",
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger", size: "sm" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.filteredOrders,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(issuedDate)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("issuedDate")
                              },
                            },
                          },
                          [_vm._v("Issue Date")]
                        ),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                          },
                          on: { change: _vm.applyDateFilters },
                          model: {
                            value: _vm.filters.issuedDateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "issuedDateRange", $$v)
                            },
                            expression: "filters.issuedDateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(createdOn)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("createdOn")
                              },
                            },
                          },
                          [_vm._v("Created On")]
                        ),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                          },
                          on: { change: _vm.applyDateFilters },
                          model: {
                            value: _vm.filters.createdOnRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "createdOnRange", $$v)
                            },
                            expression: "filters.createdOnRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(dueDate)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("dueDate")
                              },
                            },
                          },
                          [_vm._v("Due Date")]
                        ),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                          },
                          on: { change: _vm.applyDateFilters },
                          model: {
                            value: _vm.filters.dueDateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "dueDateRange", $$v)
                            },
                            expression: "filters.dueDateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(status)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Status")]),
                        _c("b-form-select", {
                          attrs: { options: _vm.statusOptions },
                          on: { change: _vm.applyFilters },
                          model: {
                            value: _vm.filters.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(total)",
                fn: function (data) {
                  return [
                    _vm._v(" Rs " + _vm._s(data.item.total.toFixed(2)) + " "),
                  ]
                },
              },
              {
                key: "cell(issuedDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.convertTimestampToDate(data.item.issuedDate)
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(orderType)",
                fn: function (data) {
                  return [
                    data.item.orderType === 1
                      ? _c("b-badge", { attrs: { variant: "primary" } }, [
                          _vm._v(" Variable Order "),
                        ])
                      : data.item.orderType === 2
                      ? _c("b-badge", { attrs: { variant: "primary" } }, [
                          _vm._v(" OneOff Order "),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    data.item.status === 0
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(" PROFORMA "),
                        ])
                      : data.item.status === 1
                      ? _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v(" ONDEMAND "),
                        ])
                      : data.item.status === 2
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v(" READY "),
                        ])
                      : data.item.status === 3
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v(" INVOICED "),
                        ])
                      : data.item.status === 4
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v(" CANCELLED "),
                        ])
                      : _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(" Blocked "),
                        ]),
                  ]
                },
              },
              {
                key: "cell(createdOn)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.convertTimestampToDate(data.item.createdOn)
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(dueDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.convertTimestampToDate(data.item.dueDate)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "text-body align-middle mr-25",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm.HasPermission(_vm.PermissionList.Sales_View)
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  to: _vm.getSalesOrderIdView(data.item.id),
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "EyeIcon" },
                                }),
                                _c("span", [_vm._v("View")]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isEdit
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  disabled: data.item.status == 3,
                                  to: _vm.getSalesOrderId(data.item.id),
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "Edit2Icon" },
                                }),
                                _c("span", [_vm._v("Edit")]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.HasPermission(_vm.PermissionList.Sales_Delete)
                          ? _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.removesalesOrder(data.item.id)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "TrashIcon" },
                                }),
                                _c("span", [_vm._v("Delete")]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.order.length === 0
                ? _c(
                    "b-alert",
                    {
                      staticClass: "d-flex justify-content-center",
                      attrs: { variant: "warning", show: "" },
                    },
                    [
                      _c("h4", { staticClass: "alert-heading" }, [
                        _vm._v("No Proformas yet"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loading
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }